export default "__VITE_ASSET__tzk8H3Mj3bVVXr7Rsdc3Eg__"